import { Constructor } from '@angular/cdk/table';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { compareArrays } from '../utils/array-utils';
import { IChapter } from 'src/app/core/models/i-chapter';

type WithChaptersFormSectionType = {
  _initChapters(chapters: IChapter[]): void;
  _initChaptersValueChanges(getPreviousChapters: () => IChapter[] | null): void;
  _buildChapters(): IChapter[];
};

type ChaptersFormSectionRequirementsBase = {
  form: FormGroup;
  FORM_PATHS: {
    CHAPTERS: () => string;
  };
  destroy$: Subject<boolean>;
};

export function WithChaptersFormSection<
  TBase extends Constructor<ChaptersFormSectionRequirementsBase>
>(
  baseClass: TBase
): {
  new (...args: any[]): WithChaptersFormSectionType;
  prototype: WithChaptersFormSectionType;
} & TBase {
  return class ChaptersSectionable extends baseClass {
    constructor(...args: any[]) {
      super(...args);
    }

    _initChapters(chapters: IChapter[]): void {
      const chaptersControl = this.form.get(
        this.FORM_PATHS.CHAPTERS()
      ) as FormArray<FormControl<IChapter>>;

      if (chapters)
        chapters.forEach((article) =>
          chaptersControl.push(new FormControl(article))
        );

      chaptersControl.markAsPristine();
    }

    _initChaptersValueChanges(
      getPreviousChapters: () => IChapter[] | null
    ): void {
      this.form
        .get(this.FORM_PATHS.CHAPTERS())
        .valueChanges.pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (newValue) => {
            if (compareArrays(newValue, getPreviousChapters())) {
              this.form.get(this.FORM_PATHS.CHAPTERS()).markAsPristine();
            } else {
              this.form.get(this.FORM_PATHS.CHAPTERS()).markAsDirty();
            }
          },
        });
    }

    _buildChapters(): IChapter[] {
      return this.form.get(this.FORM_PATHS.CHAPTERS()).value;
    }
  };
}
